import { fetchPricesOnChain } from "./fetchPrices";

export const calculateAmounts = async (
  X: number,
  ratioX1: number
): Promise<{
  amountNAUY: number;
  amountNAUN: number;
  priceNAU: number;
  priceNAUY: number;
  priceNAUN: number;
} | null> => {
  try {
    // Determine complementary ratio for NAUN
    const ratioX2 = 1 - ratioX1;

    // Retrieve latest prices from backend
    const prices = await fetchPricesOnChain();
    if (!prices) {
      console.error("❌ Failed to fetch prices, calculation aborted.");
      return null;
    }

    const { priceNAU, priceNAUY, priceNAUN } = prices;

    // Validate that all prices are positive finite numbers
    const allPricesValid = [priceNAU, priceNAUY, priceNAUN].every(
      (p) => typeof p === "number" && isFinite(p) && p > 0
    );
    if (!allPricesValid) {
      console.error(
        "❌ Error: Prices must be valid, finite, non-zero numbers."
      );
      return null;
    }

    // Compute amounts with a 1% fee factor applied to X
    const amountNAUY = Number(
      ((0.99 * X * ratioX1 * priceNAU) / priceNAUY).toFixed(4)
    );
    const amountNAUN = Number(
      ((0.99 * X * ratioX2 * priceNAU) / priceNAUN).toFixed(4)
    );

    return { amountNAUY, amountNAUN, priceNAU, priceNAUY, priceNAUN };
  } catch (error) {
    console.error("❌ Unexpected error during amounts calculation:", error);
    return null;
  }
};
